import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

import {Icon, ThreeDotsMenu, MenuCommand} from 'front-onceforall-core';

import authenticationService from '../../../services/authentication/AuthenticationService';

import DossierCountrySelector from '../../dossierCountrySelector';
import ToggleBdrBoxButton from '../../DiscoverBdrBox/ToggleBdrBoxButton';

import {useSubcontractorsStore} from '../SubcontractorsStore';

function HeaderView(props) {
  const roles = authenticationService.roles();
  const isConsultant = roles.isConsultant();
  const {state: {subcontractors}} = useSubcontractorsStore();
  const disableAddSubcontractor = isConsultant;

  return (
    <div className="row mt-4 mb-5">
      <h1 className="col-md-6 m-0">
        <Translate value="subcontractor.mySubcontractors"/>
        <span className="separator information">{subcontractors.totalCount}</span>
      </h1>
      <div className="col-md-6 flex-container flex-end">
        <ToggleBdrBoxButton/>
        <DossierCountrySelector
          countries={props.countries}
          onChange={props.onDossierCountryChange}
          value={subcontractors.dossierCountry}
        />
        {!disableAddSubcontractor &&
          <div className="flex-container ml-4">
            <button
              type="button"
              className="large cta inline-container"
              onClick={props.onOpenAddSubcontractorPanel}
            >
              <Icon icon="plus"/>
              <Translate value="subcontractor.add.button"/>
            </button>
            <ThreeDotsMenu
              data-id="my-subcontractors-actions"
              big
            >
              <MenuCommand
                data-id="my-subcontactors-actions-access-code"
                label={<Translate value="subcontractor.accessCode.label"/>}
                icon="key"
                onClick={props.onOpenAccessCodeModal}
              />
              <MenuCommand
                data-id="my-subcontactors-actions-export"
                label={<Translate value="subcontractor.export"/>}
                icon="folder-download"
                onClick={props.onDownloadExport}
              />
            </ThreeDotsMenu>
          </div>
        }
      </div>
    </div>
  );
}

HeaderView.propTypes = {
  countries: PropTypes.array.isRequired,
  onOpenAccessCodeModal: PropTypes.func.isRequired,
  onOpenAddSubcontractorPanel: PropTypes.func.isRequired,
  onDownloadExport: PropTypes.func.isRequired,
  onDossierCountryChange: PropTypes.func.isRequired
};

export default HeaderView;
